import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt thought w-100">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="mobile-scroll select-dropdown md-lg-scroll md-xl-scroll md-xxl-scroll">

                                                <div className="risk">
                                                    <div className="leftbox">
                                                        <div className="textbox1">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea1"
                                                                      value={this.props.pageData?.Countermeasures?.textarea1}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>

                                                        <div className="textbox2">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea2"
                                                                      value={this.props.pageData?.Countermeasures?.textarea2}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>


                                                        <div className="textbox3">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea3"
                                                                      value={this.props.pageData?.Countermeasures?.textarea3}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>


                                                        <div className="textbox4">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea4"
                                                                      value={this.props.pageData?.Countermeasures?.textarea4}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>


                                                    </div>

                                                    <div className="rigthbox">

                                                        <div className="textbox5">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea5"
                                                                      value={this.props.pageData?.Countermeasures?.textarea5}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>

                                                        <div className="centerbox">
                                                            <span className="ilead-slect-box">
                                                                <select className="custom-dropdown"
                                                                        style={{width:'167px'}}
                                                                        name="Bias1"
                                                                        value={this.props.pageData?.Countermeasures?.Bias1}
                                                                        onChange={this.props.handleChangePageData('Countermeasures')}>
                                                                    <option value="">Please select...</option>
                                                                    <option value="12">Anchoring or adjustment</option>
                                                                    <option value="16">Attribution</option>
                                                                    <option value="20">Attribution of causality</option>
                                                                    <option value="8">Choice / supportive bias</option>
                                                                    <option value="2">Discontinuation of evidence searching</option>
                                                                    <option value="5">Experienced based limitations</option>
                                                                    <option value="19">Generalisations</option>
                                                                    <option value="18">Illusion of control</option>
                                                                    <option value="15">Irregularity</option>
                                                                    <option value="7">Optimism</option>
                                                                    <option value="13">Peer pressure or group think</option>
                                                                    <option value="10">Primacy effect</option>
                                                                    <option value="4">Rebelliousness</option>
                                                                    <option value="9">Recency effect</option>
                                                                    <option value="11">Repetition bias</option>
                                                                    <option value="6">Selective perception</option>
                                                                    <option value="1">Selective searching for evidence</option>
                                                                    <option value="17">Self Fulfilling Prophecy</option>
                                                                    <option value="14">Source credibility bias</option>
                                                                    <option value="3">Unwillingness to change thought patterns</option>
                                                                </select>
                                                            </span>
                                                        </div>


                                                        <div className="textbox6">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea6"
                                                                      value={this.props.pageData?.Countermeasures?.textarea6}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>


                                                        <div className="centerbox2">
                                                             <span className="ilead-slect-box">
                                                                <select className="custom-dropdown"
                                                                        style={{width:'167px'}}
                                                                        name="Bias2"
                                                                        value={this.props.pageData?.Countermeasures?.Bias2}
                                                                        onChange={this.props.handleChangePageData('Countermeasures')}>
                                                                    <option value="">Please select...</option>
                                                                    <option value="12">Anchoring or adjustment</option>
                                                                    <option value="16">Attribution</option>
                                                                    <option value="20">Attribution of causality</option>
                                                                    <option value="8">Choice / supportive bias</option>
                                                                    <option value="2">Discontinuation of evidence searching</option>
                                                                    <option value="5">Experienced based limitations</option>
                                                                    <option value="19">Generalisations</option>
                                                                    <option value="18">Illusion of control</option>
                                                                    <option value="15">Irregularity</option>
                                                                    <option value="7">Optimism</option>
                                                                    <option value="13">Peer pressure or group think</option>
                                                                    <option value="10">Primacy effect</option>
                                                                    <option value="4">Rebelliousness</option>
                                                                    <option value="9">Recency effect</option>
                                                                    <option value="11">Repetition bias</option>
                                                                    <option value="6">Selective perception</option>
                                                                    <option value="1">Selective searching for evidence</option>
                                                                    <option value="17">Self Fulfilling Prophecy</option>
                                                                    <option value="14">Source credibility bias</option>
                                                                    <option value="3">Unwillingness to change thought patterns</option>
                                                                </select>
                                                            </span>
                                                        </div>

                                                        <div className="textbox7">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea7"
                                                                      value={this.props.pageData?.Countermeasures?.textarea7}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>

                                                        <div className="textbox8">
                                                            <textarea className="balancerisk_textarea"
                                                                      rows="1"
                                                                      cols="10"
                                                                      name="textarea8"
                                                                      value={this.props.pageData?.Countermeasures?.textarea8}
                                                                      onChange={this.props.handleChangePageData('Countermeasures')}/>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">BALANCING RISK EXERCISE</span>
                                            </div>
                                            <p>This will help you decide whether the risks of a particular
                                                course of action outweigh the benefits. First, carry out a
                                                SWOT analysis<a className="superscripttext"
                                                                href="further_info.php?course=300"><sup>6</sup></a> of
                                                the situation (another acronym, this time for Strengths,
                                                Weaknesses, Opportunities and Threats):</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}